export class VTPaymentRequest {
  MerchantID: string = '';
  CountryCode: string = '';
  ResponseAction: string = '';
  CAType: string = '';
  AcceptCof: string = '';
  QAProducts: string = '';
  QAName: string = '';
  MotoType: string = '';
  Dispatch: string = '';
  CurrencyCode: string = '';
  Amount: number = 0;
  PaymentDetail: string = '';
  PaymentReference: string = '';
  LIDItem1Description: string = '';
  LIDItem1Quantity: number = 1;
  LIDItem1GrossValue: number = 0;
  CardNumber: string = '';
  CV2: string = '';
  CardExpiryMonth: string = '';
  CardExpiryYear: string = '';
  CardExpiry: string = '';
  IdempotencyToken: string = '';
  EmailAddress: string = '';
  OrderId: string = '';
}

export class VTPaymentResponse {
  status: boolean = false;
  message: string = '';
  idempotencyToken: string = '';
  time: Date = new Date();
  traceId: string = '';
}
